import { DaysOfWeek } from '@services/service-dashboard/service-attendance-register/service-attendance-weekly-schedule/enums/days-of-week.enum';

export const weekdaysMapping: { [k: number]: DaysOfWeek } = {
    1: DaysOfWeek.monday,
    2: DaysOfWeek.tuesday,
    3: DaysOfWeek.wednesday,
    4: DaysOfWeek.thursday,
    5: DaysOfWeek.friday,
    6: DaysOfWeek.saturday,
    7: DaysOfWeek.sunday,
};
